import { SolAds } from "./SolAdsClass"

export function formatSolItem(item: typeof $, finishedCallback: (type: string, b: boolean) => void) {
    if (item.hasClass("sol-type-display")) {
        // Entferne automatisch gesetztes SolAds-Label
        item.find(".m3_container * + div").not("[class]").remove()

        return finishedCallback(SolAds.Type.DisplayAd, true)
    }

    // Aussagekräftigere Klassen für TextAd Elemente setzen
    const solLink = item.find(".a")
    const solImageContainer = item.find(".i")
    const solImage = solImageContainer.find("img")
    const solTextContainer = item.find(".x")
    const solTitle = item.find(".t")
    const solDescription = item.find(".d")
    const solSlogan = item.find(".u")

    if (!solLink.length || solLink.hasClass("sol-link")) {
        return finishedCallback(SolAds.Type.TextAd, false)
    }

    solLink.addClass("sol-link")

    if (solTextContainer.length > 0) {
        solImageContainer.addClass("solads-image-container")
        solTextContainer.addClass("text-container")
    }

    solImage.addClass("fullwidth-image retain-aspect-ratio")
    solTitle.addClass("sol-header")
    solDescription.addClass("link-text")
    solSlogan.addClass("sol-text")

    if (!solLink.closest(".sol-row").length) {
        const columnCount = item.data("columns") || 1

        addSolWrapper(item, solLink, columnCount)
    }

    finishedCallback(SolAds.Type.TextAd, true)
}

export function addSolWrapper(rootElement: typeof $, contentElements: typeof $, columnCount: number) {
    const parentElement = rootElement.find(".m3_container")

    contentElements.each((index: number, newElement: typeof $) => {
        const element = $(newElement)

        const columnIndex = `column-${(index % columnCount) + 1}`
        let column = rootElement.find(`.${columnIndex}`)
        const item = $("<div>")
        const itemId = `sol-item-${index + 1}`

        if (!column.length) {
            // Erstelle eine neue Spalte, wenn für das aktuelle Element
            // 	noch keine existiert
            column = $("<section>").addClass(`sol-column ${columnIndex}`)
            column.appendTo(parentElement)

            parentElement.find("> :not(section)").remove()
        }

        item.prop("id", itemId)
        item.addClass(`sol-item ${itemId}`)

        element.appendTo(item)
        item.appendTo(column)
    })

    // Setze die Anzahl der Spalten als Klasse auf den Container
    parentElement.addClass(`columns-${parentElement.find(".sol-column").length}`)
}
